import styled, { css } from "styled-components";

interface IContainerProps {
	$isRecommended?: boolean;
	$isBlocked?: boolean;
}
export const Container = styled.div<IContainerProps>`
	position: relative;
	cursor: pointer;
	background-color: ${({ theme }) => theme.white};
	border: 1px solid ${({ $isRecommended, theme }) => ($isRecommended ? theme.pantone2726C : theme.grayDark)};
	border-radius: 8px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	padding: 0.4rem 0.4rem;
	width: 100%;
	min-height: 370px;
	height: 100%;

	&.box-layout-card-collumn {
		padding: 0;
		border-radius: 0;
	}

	${(props) =>
		props.$isBlocked &&
		css`
			cursor: not-allowed;
			border: 1px solid props.theme.grayDark;
			opacity: 0.8;
			filter: grayscale(0.6);

			.MuiButtonBase-root {
				cursor: not-allowed;
			}
		`};

	&:hover {
		background: ${({ theme }) => theme.grayLight};
	}
`;

//#region Header
export const Header = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
`;
export const TextSupplier = styled.div`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	font-weight: bold;
	font-size: 1rem;
	font-weight: bold;
	margin: 0 0 0.6rem;
`;
export const AreaFavorite = styled.div``;
//#endregion

//#region Content
export const Content = styled.div``;
export const AreaImage = styled.div`
	> img {
		width: 100%;
		max-width: 185px;
		max-height: 185px;
		min-width: 185px;
		min-height: 185px;
		object-fit: contain;
	}
`;
export const AreaTextCode = styled.div``;
export const TextPartCode = styled.span`
	font-weight: bold;
`;
export const TextPartType = styled.span``;
export const TextPart = styled.span``;
export const TextPartTitle = styled.p`
	margin-bottom: 0.4rem;
`;
export const TextDeliveryTime = styled.p`
	margin-bottom: 0.4rem;
`;
export const AreaDescription = styled.div``;
export const AreaEvaluation = styled.div``;
export const AreaButtons = styled.div`
	margin: 0.6rem 0;

	#id-createOrder-button-card-paint {
		padding: 0.4rem 0.2rem;
	}
`;
//#endregion
